<template>
  <input-widget
      :model="model"
      :attribute="attribute"
      type="select2"
      :items="bidderStatusOptions"
      :hint="hint"
      :disabled="disabled"
      display-field="${item.key}"
      value-field="value"
      :options="options"
      :label="label"/>
</template>

<script>
import InputWidget from "../components/input-widget/InputWidget";
import {createNamespacedHelpers} from "vuex";

const {mapState: mapStateGlobal} = createNamespacedHelpers('global');


export default {
  name: "BidderStatusSelectInputWidget",
  components: {InputWidget},
  props: {
    model: {
      type: Object,
      required: true,
    },
    attribute: {
      type: String,
      required: true
    },
    hint: {
      type: [Boolean, String],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    },
    label: {
      type: [String, Boolean],
      default: null
    },
  },
  computed: {
    ...mapStateGlobal({
      bidderStatusOptions: state => state.bidderStatusOptions,
    }),
  }
}
</script>

<style scoped>

</style>
